import React, { Component, FormEvent } from 'react';
import FormicaInput from '../../custom/FormicaInput';
import FormicaLabel from '../../custom/FormicaLabel';
import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import {
  WatchlistConfiguration,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRequest,
  WatchlistListsModel,
} from '../../../domain/watchlist/WatchlistDomains';
import moment from 'moment/moment';
import WatchlistUtil from '../../../util/WatchlistUtil';
import CustomMultiSelect from '../../custom/CustomMultiSelect';
import { MultiSelectChangeParams } from 'primereact/multiselect';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import { AnimatedButton } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistIndividualSearchComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { phoneCode } = this.state;
    const { searchRequest, requestLoading, search } = this.props;

    return (
      <div className={'h-full w-full bg-[#F9FAFB]'}>
        <div className={'w-full flex flex-col items-center p-5 gap-y-4 h-[calc(100vh-15rem)] overflow-y-scroll'}>
          <div className={'w-full'}>
            <div className={'flex lg:flex-row flex-col gap-4 pb-2'}>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })} />
                <FormicaInput onChange={this.onChangeName} placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })} />
              </div>
              <div className={'flex flex-col w-full gap-y-1'}>
                <div className={'flex flex-col w-full gap-y-1'}>
                  <FormicaLabel label={LanguageUtil.get({ id: 'common.label.identification', defaultMessage: 'Identification / Identifier' })} />
                  <FormicaInput
                    onChange={this.onChangeIdentification}
                    placeholder={LanguageUtil.get({ id: 'common.input.placeholder.identification', defaultMessage: 'Identification / Identifier' })}
                  />
                </div>
              </div>
            </div>
            <div className={'flex lg:flex-row flex-col gap-4 pb-2'}>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.registration', defaultMessage: 'Date of Birth / Registration' })} />
                <Calendar
                  className={'!h-[34px]  border-[1px] border-f-black-5 rounded'}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.registration', defaultMessage: 'Date of Birth / Registration' })}
                  value={searchRequest.dateOfBirth ? moment(searchRequest.dateOfBirth, 'DD/MM/YYYY').toDate() : null}
                  dateFormat={'dd/mm/yy'}
                  onChange={this.onChangeDateOfBirth}
                />
              </div>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.citizenship', defaultMessage: 'Citizenship' })} />
                <FormicaSearchSelectBox
                  options={WatchlistUtil.getCitizenshipList()}
                  className={'indent-1'}
                  value={searchRequest?.citizenship || undefined}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.citizenship', defaultMessage: 'Citizenship' })}
                  onChange={this.onChangeCitizenship}
                />
              </div>
            </div>
            <div className={'flex lg:flex-row flex-col gap-4 pb-2'}>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.emailAddress', defaultMessage: 'Email Address' })} />
                <FormicaInput
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.emailAddress', defaultMessage: 'Email Address' })}
                  onChange={this.onChangeEmail}
                />
              </div>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.phoneNumber', defaultMessage: 'Phone Number' })} />
                <div className={'flex items-center w-full'}>
                  <div className={'flex w-[150px]'}>
                    <FormicaSearchSelectBox
                      options={WatchlistUtil.phoneList()}
                      placeholder={LanguageUtil.get({ id: 'common.input.placeholder.countryCode', defaultMessage: 'Country Code' })}
                      className={'indent-1'}
                      value={phoneCode}
                      onChange={this.onChangePhoneCode}
                    />
                  </div>
                  <div className={'flex w-full items-center'}>
                    <FormicaInput
                      placeholder={LanguageUtil.get({ id: 'common.label.phoneNumber', defaultMessage: 'Phone Number' })}
                      type={'number'}
                      className={'!rounded-l-none'}
                      onChange={this.onChangePhone}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={'flex lg:flex-row flex-col gap-4 pb-2'}>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.threshold', defaultMessage: 'Threshold *' })} />
                <FormicaInput
                  onChange={this.onChangeThreshold}
                  value={searchRequest.threshold}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.threshold', defaultMessage: 'Threshold' })}
                />
              </div>
              <div className={'flex flex-col w-full gap-y-1 overflow-auto'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.lists', defaultMessage: 'Lists' })} />
                <CustomMultiSelect
                  items={[...this.getListSelectOptions(), ...this.getGroupSelectOptions()]}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.lists', defaultMessage: 'Lists' })}
                  selectedItems={searchRequest.lists}
                  label={LanguageUtil.get({ id: 'common.label.lists', defaultMessage: 'Lists' })}
                  onChange={(e: MultiSelectChangeParams) => this.onSelectListsField(e)}
                />
              </div>
            </div>
            <div className={'flex lg:flex-row flex-col gap-4 pb-2'}>
              <div className={'flex flex-col w-full gap-y-1'}>
                <FormicaLabel label={LanguageUtil.get({ id: 'common.label.referenceId', defaultMessage: 'Reference ID' })} />
                <FormicaInput
                  onChange={this.onChangeReferenceId}
                  value={searchRequest.referenceId ?? ''}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.referenceId', defaultMessage: 'enter the reference ID' })}
                />
              </div>
              <div className={'flex flex-col w-full gap-y-1'}></div>
            </div>
            <div className={'flex flex-col gap-4 pt-4'}>
              <div className={'flex flex-row w-full gap-x-1 justify-end'}>
                <AnimatedButton
                  customSize={'md'}
                  loading={requestLoading}
                  icon={'search'}
                  text={LanguageUtil.get({ id: 'common.button.search', defaultMessage: 'Search' })}
                  customType={'primary'}
                  onClick={search}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const { onChangeRequest } = this.props;
    onChangeRequest(WatchlistUtil.initializeIndividualKycRequest());
  }

  private getListSelectOptions = () => {
    const { lists } = this.props;
    if (lists == undefined || lists.length == 0) return [];
    return lists?.map((value: WatchlistListsModel) => ({
      label: value.name,
      value: value.id,
    }));
  };

  private getGroupSelectOptions = () => {
    const { watchlistConfiguration } = this.props;
    if (watchlistConfiguration == undefined || watchlistConfiguration.length == 0) return [];
    return watchlistConfiguration?.map((value) => ({
      label: value.id,
      value: value.id,
    }));
  };

  private onChangeThreshold = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    let value = Number(e.currentTarget.value);
    if (value > 100) {
      searchRequest.threshold = 100;
    } else if (isNaN(value) || value < 0) {
      searchRequest.threshold = 0;
    } else {
      searchRequest.threshold = value;
    }
    onChangeRequest(searchRequest);
  };

  private onChangeName = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    searchRequest.name = e.currentTarget.value;
    onChangeRequest(searchRequest);
  };

  private onChangeDateOfBirth = (e: CalendarChangeParams) => {
    const { searchRequest, onChangeRequest } = this.props;
    const value: any = e.value;
    if (value) {
      searchRequest.dateOfBirth = moment(value).format('DD/MM/YYYY');
      onChangeRequest(searchRequest);
    }
  };

  private onChangeCitizenship = (e: FormicaSelectBoxItem) => {
    const { searchRequest, onChangeRequest } = this.props;
    searchRequest.citizenship = e.value;
    onChangeRequest(searchRequest);
  };

  private onChangeIdentification = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    searchRequest.identification = e.currentTarget.value;
    onChangeRequest(searchRequest);
  };

  private onSelectListsField = (e: MultiSelectChangeParams) => {
    const { searchRequest, onChangeRequest } = this.props;
    if (e.value) {
      searchRequest.lists = e.value;
      onChangeRequest(searchRequest);
    }
  };

  private onChangeEmail = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    searchRequest.email = e.currentTarget.value;
    onChangeRequest(searchRequest);
  };

  private onChangeReferenceId = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    searchRequest.referenceId = e.currentTarget.value;
    onChangeRequest(searchRequest);
  };

  private onChangePhoneCode = (e: FormicaSelectBoxItem) => {
    const value = e.value;
    if (value) {
      this.setState({
        phoneCode: value,
      });
    }
  };

  private onChangePhone = (e: FormEvent<HTMLInputElement>) => {
    const { searchRequest, onChangeRequest } = this.props;
    const { phoneCode } = this.state;
    const value = e.currentTarget.value;
    if (phoneCode) {
      searchRequest.phone = phoneCode + value;
    } else {
      searchRequest.phone = value;
    }
    onChangeRequest(searchRequest);
  };
}

interface Props {
  searchRequest: WatchlistIndividualRequest;
  onChangeRequest: (searchRequest: Partial<WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest>) => void;
  search: () => void;
  requestLoading: boolean;
  watchlistConfiguration: WatchlistConfiguration[];
  lists: WatchlistListsModel[];
}

class State {
  phoneCode: string | undefined;
}

export default WatchlistIndividualSearchComponent;
